<template>
	<az-bpm-action
		:after-action="actionAfterBpm"
		:before-action="tratarParametros"
		:business-key="businessKey"
		:button-attrs="{
			claim: {
				class: getClassButton('claim', `text-none order-0 text-uppercase ${botaoClasse}`),
				outlined: true,
			},
			unclaim: {
				class: getClassButton(
					'unclaim',
					`text-none order-1 ms-3 text-uppercase v-btn--width-auto ${botaoClasse}`,
				),
				text: true,
			},
			complete: {
				class: getClassButton(
					'complete',
					`text-none order-0 text-uppercase ${botaoClasse} ${temProximaTask ? 'd-flex' : 'd-none'}`,
				),
				outlined: true,
			},
			uncomplete: {
				class: getClassButton('uncomplete', `text-none order-1 ms-3 text-uppercase ${botaoClasse}`),
				text: true,
			},
		}"
		:process-key="process_key"
		class="bpm-action-adesao"
	>
		<template #claim="{ button }">
			<span v-if="false">{{ button.label }}</span>
		</template>
		<template #unclaim="{ button }">
			<icone-tooltip tamanho="auto" icone="mdi-undo-variant" :texto="button.label" cor="white"></icone-tooltip>
		</template>
		<template #uncomplete="{ button }">
			<icone-tooltip tamanho="auto" icone="mdi-undo-variant" :texto="button.label" cor="white"></icone-tooltip>
		</template>
	</az-bpm-action>
</template>
<script>
import arpBpmAdesaoMixin from '@/views/mixins/bpm/adesao/arp-bpm-adesao-mixin'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'

export default {
	name: 'arp-bpm-adesao',
	components: { BotaoPrimario },
	mixins: [arpBpmAdesaoMixin],
	async mounted() {
		await this.atualizaInstanciaDoProcesso()
	},
}
</script>
